// extracted by mini-css-extract-plugin
export default {"project":"TimeList_project__YbD1z","circle":"TimeList_circle__qaA33","title":"TimeList_title__Ufqua","dark":"TimeList_dark__2tfkl","line":"TimeList_line__+opil"};